import React from "react";
import { useTranslation } from "react-i18next";
import InputLabel from "@mui/material/InputLabel";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { useSharedSelector } from "../../../store/SharedProvider";
import ReadOnlyProtectedIconButton from "../../Inputs/ReadOnlyProtectedIconButton";
import Mission from "../../../interfaces/robot/missions/mission";
import CleaningCommandButton, { mapButtonIdToName } from "../../../interfaces/robot/buttons/command-buttons";
import { getNavigatorDescription, navigators } from "../../../interfaces/robot/navigator";
import { NavigatorAvailability } from "../../../enums/command-hub/navigator";
import { selectIsAdvancedModeEnabled } from "../../../store/app-configurations/app-configurations-selectors";
import { EditIcon } from "../../../utils/icons/icons";
import Stack from "@mui/material/Stack";
import FormHelperText from "@mui/material/FormHelperText";

const ButtonRow: React.FC<{
  hideLabel?: boolean;
  cleaningButton: CleaningCommandButton;
  mission?: Mission;
  onClick: () => void;
}> = ({ hideLabel, cleaningButton, mission, onClick }) => {
  const { t } = useTranslation();

  const isAdvancedModeEnabled = useSharedSelector((state) => selectIsAdvancedModeEnabled(state));

  const configDisabled =
    !isAdvancedModeEnabled &&
    navigators.some((n) => n.availability !== NavigatorAvailability.Public && n.name === mission?.mode);

  const buttonTitle = mission == null ? "" : `${mission.room != null ? mission.name + " - " : ""}${getNavigatorDescription(mission.mode)}`;

  return (
    <React.Fragment>
      <Stack direction="row" alignItems="center">
        <Stack flexGrow={1}>
          {hideLabel !== true && <InputLabel>{t(mapButtonIdToName(cleaningButton.id))}</InputLabel>}
          <Typography pt={0.5}>{buttonTitle}</Typography>

          {configDisabled && <FormHelperText>{t("requires-advanced-mode")}</FormHelperText>}
        </Stack>
        <Tooltip title={t("configure-button")}>
          <span>
            <ReadOnlyProtectedIconButton size="small" onClick={onClick} disabled={configDisabled} color="success">
              <EditIcon />
            </ReadOnlyProtectedIconButton>
          </span>
        </Tooltip>
      </Stack>
    </React.Fragment>
  );
};

export default ButtonRow;
